export default "__VITE_ASSET__b71b2a76__"